var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "text-right mt-2 mb-2" },
        [
          _c("data-download", {
            attrs: { data: _vm.tableData, filename: "gene_associations" },
          }),
        ],
        1
      ),
      _vm.gene && _vm.rows > 0
        ? _c("b-table", {
            attrs: {
              hover: "",
              small: "",
              responsive: "",
              items: _vm.tableDataWithDetails,
              fields: _vm.fields,
              "per-page": _vm.perPage,
              "current-page": _vm.currentPage,
              "detail-key": "_rowKey",
              "show-empty": "",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "cell(phenotype)",
                  fn: function (r) {
                    return [
                      _c(
                        "a",
                        {
                          staticClass: "phenotype-gene-association",
                          attrs: { href: "javascript:;" },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.phenotypeFormatter(
                                  _vm.phenotypeMap[r.item.phenotype]
                                )
                              ) +
                              " "
                          ),
                          _c("div", { staticClass: "options-4-actions" }, [
                            _c("div", [
                              _vm.phenotypeMap
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: `/phenotype.html?phenotype=${r.item.phenotype}`,
                                      },
                                    },
                                    [_vm._v("Open phenotype page")]
                                  )
                                : _vm._e(),
                            ]),
                            _c("div", [
                              _vm.phenotypeMap
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: `/region.html?phenotype=${r.item.phenotype}&chr=${_vm.gene.chromosome}&start=${_vm.gene.start}&end=${_vm.gene.end}`,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "Open region page with selected phenotype"
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v("   "),
                    ]
                  },
                },
                {
                  key: "cell(cfde_gene_set)",
                  fn: function (r) {
                    return [
                      _c(
                        "button",
                        {
                          staticClass: "btn view-features-btn btn-secondary",
                          on: {
                            click: function ($event) {
                              return _vm.toggleGeneSetDetails(r.item)
                            },
                          },
                        },
                        [_vm._v(" View Gene Sets ")]
                      ),
                    ]
                  },
                },
                {
                  key: "row-details",
                  fn: function (row) {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "p-3",
                          staticStyle: {
                            "background-color": "#eeeeee",
                            "border-left": "5px solid #cccccc",
                          },
                        },
                        [
                          _vm.getGeneSetSubtableLoading(row.item)
                            ? _c("div", { staticClass: "text-muted" }, [
                                _vm._v(" Loading gene sets... "),
                              ])
                            : _vm.getGeneSetSubtableError(row.item)
                            ? _c("div", { staticClass: "text-danger" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.getGeneSetSubtableError(row.item)
                                    ) +
                                    " "
                                ),
                              ])
                            : [
                                _c(
                                  "div",
                                  {
                                    staticClass: "kc-logo-container",
                                    staticStyle: {
                                      position: "relative",
                                      height: "70px",
                                      "margin-top": "-20px",
                                    },
                                  },
                                  [_c("kc-cfde-logo")],
                                  1
                                ),
                                _c("b-table", {
                                  attrs: {
                                    small: "",
                                    responsive: "",
                                    items: _vm.getGeneSetSubtableData(row.item),
                                    fields: _vm.geneSetSubtableFields,
                                    "per-page": _vm.geneSetSubtablePerPage,
                                    "current-page": _vm.getGeneSetSubtablePage(
                                      row.item
                                    ),
                                    "show-empty": "",
                                    "empty-text": "No gene set data.",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: _vm.geneSetCellSlot,
                                        fn: function (cell) {
                                          return [
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: `https://cfdeknowledge.org/r/kc_gsb?geneSet=${encodeURIComponent(
                                                    cell.value || ""
                                                  )}`,
                                                  title: cell.value,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatGeneSetCell(
                                                      cell.value
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(Source)",
                                        fn: function (cell) {
                                          return [
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: `https://cfdeknowledge.org/r/kc_gsb?source=${encodeURIComponent(
                                                    cell.value || ""
                                                  )}`,
                                                },
                                              },
                                              [_vm._v(_vm._s(cell.value))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                                _vm.getGeneSetSubtableData(row.item).length >
                                _vm.geneSetSubtablePerPage
                                  ? _c("b-pagination", {
                                      staticClass:
                                        "pagination-sm justify-content-center mt-2",
                                      attrs: {
                                        value: _vm.getGeneSetSubtablePage(
                                          row.item
                                        ),
                                        "total-rows":
                                          _vm.getGeneSetSubtableData(row.item)
                                            .length,
                                        "per-page": _vm.geneSetSubtablePerPage,
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.setGeneSetSubtablePage(
                                            row.item,
                                            $event
                                          )
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ],
                        ],
                        2
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              2726446725
            ),
          })
        : _c(
            "div",
            [
              _c(
                "b-alert",
                {
                  staticClass: "text-center",
                  attrs: { show: "", variant: "warning" },
                },
                [
                  _c("b-icon", { attrs: { icon: "exclamation-triangle" } }),
                  _vm._v(" No data available for this query. "),
                ],
                1
              ),
            ],
            1
          ),
      _c("b-pagination", {
        staticClass: "pagination-sm justify-content-center",
        attrs: { "total-rows": _vm.rows, "per-page": _vm.perPage },
        model: {
          value: _vm.currentPage,
          callback: function ($$v) {
            _vm.currentPage = $$v
          },
          expression: "currentPage",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }